import { createFileRoute } from '@tanstack/react-router'
import { StoreInventoryDashboard } from '@/components/store/StoreInventoryDashboard'
import { parseInventorySearch, type InventorySearch } from '@/components/store/inventoryRouteSearch'

export const Route = createFileRoute('/admin/inventory')({
  validateSearch: (search: Record<string, unknown>): InventorySearch =>
    parseInventorySearch(search),
  component: StoreInventoryDashboard,
})
